import {
  DriverRequests,
  ExceptionsAndOpportunity,
  LoadTime,
  RouteStatus,
  StopType,
} from "../../enums/RouteFilterTypes";
import { FilterTypes } from "../../models/route";
import {
  ALL,
  OPEN,
  READY,
  DOWNLOADED,
  IN_BUILD,
  LOADING,
  DEPARTED,
  POSTCODE,
  DUTY,
  SERVICE,
  OPPORTUNITY,
  TEN_THIRTY,
  TWELVE,
  EVENING,
  REQUESTS,
  ON_SCHEDULE,
  BEHIND_SCHEDULE,
  SCAN_TIME_EXCEEDED,
} from "../../constants/strings";

const StatusFilters = [
  {
    label: ALL,
    value: "",
  },
  {
    label: OPEN,
    value: RouteStatus.Open,
  },
  {
    label: READY,
    value: RouteStatus.Ready,
  },
  {
    label: DOWNLOADED,
    value: RouteStatus.Downloaded,
  },
  {
    label: IN_BUILD,
    value: RouteStatus.InBuild,
  },
  {
    label: LOADING,
    value: RouteStatus.Loading,
  },
  {
    label: DEPARTED,
    value: RouteStatus.Departed,
  },
];

const ExceptionsAndOpportunityFilters = [
  {
    label: ALL,
    value: "",
  },
  {
    label: POSTCODE,
    value: ExceptionsAndOpportunity.Postcode,
  },
  {
    label: DUTY,
    value: ExceptionsAndOpportunity.Duty,
  },
  {
    label: SERVICE,
    value: ExceptionsAndOpportunity.Service,
  },
  {
    label: OPPORTUNITY,
    value: ExceptionsAndOpportunity.Opportunity,
  },
];

const StopTypeFilters = [
  {
    label: ALL,
    value: "",
  },
  {
    label: TEN_THIRTY,
    value: StopType.TenThirty,
  },
  {
    label: TWELVE,
    value: StopType.Twelve,
  },
  {
    label: EVENING,
    value: StopType.Evening,
  },
];

const DriverRequestsFilters = [
  {
    label: ALL,
    value: "",
  },
  {
    label: REQUESTS,
    value: DriverRequests.Requests,
  },
];

const LoadTimeFilters = [
  {
    label: ALL,
    value: "",
  },
  {
    label: ON_SCHEDULE,
    value: LoadTime.OnSchedule,
  },
  {
    label: BEHIND_SCHEDULE,
    value: LoadTime.BehindSchedule,
  },
  {
    label: SCAN_TIME_EXCEEDED,
    value: LoadTime.ScanTimeExceeded,
  },
];

export default [
  {
    title: "Route Status",
    field: FilterTypes.routeStatus,
    values: StatusFilters,
  },
  {
    title: "Exceptions & Opportunity",
    field: FilterTypes.exceptionsAndOpportunity,
    values: ExceptionsAndOpportunityFilters,
  },
  {
    title: "Stop Type",
    field: FilterTypes.stopType,
    values: StopTypeFilters,
  },
  {
    title: "Driver Requests",
    field: FilterTypes.driverRequests,
    values: DriverRequestsFilters,
  },
  {
    title: "Load Time",
    field: FilterTypes.loadTime,
    values: LoadTimeFilters,
  },
];
